import React, { useState, useEffect } from 'react';
// import './add-questions-modal.styles.scss'
import { Modal, Button } from 'react-bootstrap';

import CreateSurveyQuestionModal from '../../CreateSurveyQuestions/create-survey-question-modal.component';

import SurveyInEditQuestionTable from './survey-in-edit-question-table.component';

const AddInEditQuestionModal = ({ sectionId, masterData, setMasterData, showQuestionsModal, setShowQuestionsModal, setFirstInitiation }) => {

    const [showCreateModal, setCreateShowModal] = useState(false);

    return (

        <Modal

            show={showQuestionsModal}
            key={sectionId}

            fullscreen={true}

        >
            <Modal.Header >

                <Modal.Title>Add Questions</Modal.Title>
                <Button
                    variant='no-variant'
                    className='modal-cancel-button'
                    onClick={() => {
                        setShowQuestionsModal(false);
                    }}>
                    Close
                </Button>
            </Modal.Header>

            <Modal.Body >
                {/* <Button
                    variant='no-variant'
                    className='modal-cancel-button'
                    onClick={() => {
                        setCreateShowModal(true);
                    }}>
                    Create New Question
                </Button>
                <CreateSurveyQuestionModal
                    setShowModal={setCreateShowModal}
                    showModal={showCreateModal}
                    setMasterData={setMasterData}
                    masterData={masterData}
                    setFirstInitiation={setFirstInitiation}
                /> */}

                <SurveyInEditQuestionTable
                    key={sectionId}
                    masterData={masterData}
                    setMasterData={setMasterData}
                    sectionId={sectionId}
                />


            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>

        </Modal>
    );
};

export default AddInEditQuestionModal;
